<form novalidate>
    <ion-textarea (ionFocus)="gotFocus()" (ionBlur)="lostFocus()" [(ngModel)]="currentValue" [ngModelOptions]="{standalone: true}" [attr.maxlength]="maxLength" [disabled]="disabled ? '' : null" [placeholder]="placeholder ? placeholder : ''" (ionChange)="inputChanged()" class="ion-textarea" autosize></ion-textarea>
    <div *ngIf="maxLength && !disabled" class="textarea-counter">{{ currentValue?.length }} / {{ maxLength }}</div>
</form>
